import { useEffect, useState } from 'react';

import { useAccountGeneratingTickets } from 'queries/tickets/useAccountGeneratingTickets';
import { useAccountTicketsOverview } from 'queries/tickets/useAccountTicketsOverview';
import { RefetchTime } from 'queries/types';

import { isEventToday, sortByStartDateTime } from 'components/@events/utils';

/**
 * Wraps a couple of hooks and state
 */
export const useAccountTickets = () => {
  const [refetchInterval, setRefetchInterval] = useState(0);
  const {
    generatingTickets: isGeneratingTickets,
    status: generatingTicketsStatus,
  } = useAccountGeneratingTickets(
    {},
    {
      refetchInterval,
    },
  );
  const {
    pastEvents,
    upcomingEvents,
    isLoading: isLoadingEvents,
    status,
    refetch,
  } = useAccountTicketsOverview();

  const upcomingEventsSorted = upcomingEvents
    .sort((a, b) => (isEventToday(a) && !isEventToday(b) ? -1 : 1))
    .sort?.((a, b) => sortByStartDateTime(a, b, 'asc'));

  useEffect(() => {
    if (generatingTicketsStatus === 'success') {
      // Start our retry interval when we don't have pdf tickets
      setRefetchInterval(isGeneratingTickets ? RefetchTime.FIVE_SECONDS : 0);
      if (!isGeneratingTickets) refetch();
    }
    if (generatingTicketsStatus === 'error') {
      setRefetchInterval(0);
    }
  }, [isGeneratingTickets, generatingTicketsStatus, refetch]);

  return {
    isLoadingEvents,
    isGeneratingTickets,
    upcomingEvents: upcomingEventsSorted,
    pastEvents,
    status,
    generatingTicketsStatus,
  };
};
